import React from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const Sidebar = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const { logout, currentUser } = useAuth();

    const isActive = (path) => {
        return location.pathname === path ? 'active' : '';
    };

    const handleLogout = async () => {
        try {
            await logout();
            navigate('/login');
        } catch (error) {
            console.error('Logout error:', error);
        }
    };

    const handleLogoClick = (e) => {
        e.preventDefault();
        window.location.href = window.location.pathname;
    };

    return (
        <div className="sidebar">
            <div className="sidebar-header" style={{ textAlign: 'center', padding: '20px 0' }}>
                <a href={window.location.pathname} onClick={handleLogoClick} style={{ textDecoration: 'none' }}>
                    <img 
                        src="/logo-mercado.png" 
                        alt="Mercado Íntimo Admin" 
                        style={{ 
                            height: '55px', 
                            width: 'auto', 
                            margin: '0 auto', 
                            cursor: 'pointer',
                            borderRadius: '4px',
                            filter: 'drop-shadow(0 4px 8px rgba(0, 0, 0, 0.25))',
                            transition: 'transform 0.2s ease'
                        }} 
                        onMouseOver={(e) => e.currentTarget.style.transform = 'scale(1.05)'}
                        onMouseOut={(e) => e.currentTarget.style.transform = 'scale(1)'}
                    />
                </a>
            </div>
            <ul className="sidebar-menu">
                <li className={isActive('/dashboard')}>
                    <Link to="/dashboard">
                        <i className="fas fa-home"></i> Dashboard
                    </Link>
                </li>
                <li className={isActive('/produtos')}>
                    <Link to="/produtos">
                        <i className="fas fa-shopping-cart"></i> Produtos
                    </Link>
                </li>
                <li className={isActive('/categorias')}>
                    <Link to="/categorias">
                        <i className="fas fa-tags"></i> Categorias
                    </Link>
                </li>
                <li className={isActive('/whatsapp')}>
                    <Link to="/whatsapp">
                        <i className="fab fa-whatsapp"></i> WhatsApp
                    </Link>
                </li>
                <li className={isActive('/affiliates')}>
                    <Link to="/affiliates">
                        <i className="fas fa-handshake"></i> Afiliados
                    </Link>
                </li>
                <li className={isActive('/banners')}>
                    <Link to="/banners">
                        <i className="fas fa-images"></i> Gerenciar Banners
                    </Link>
                </li>
                <li className={isActive('/lojas')}>
                    <Link to="/lojas">
                        <i className="fas fa-store"></i> Gerenciar Lojas
                    </Link>
                </li>
                <li className={isActive('/blog')}>
                    <Link to="/blog">
                        <i className="fas fa-edit"></i> Blog/Conteúdo
                    </Link>
                </li>
                <li className={isActive('/comentarios')}>
                    <Link to="/comentarios">
                        <i className="fas fa-comments"></i> Comentários
                    </Link>
                </li>
                <li className={isActive('/validacao-notas')}>
                    <Link to="/validacao-notas">
                        <i className="fas fa-receipt"></i> Validação de Notas
                    </Link>
                </li>
                <li className={isActive('/resgates')}>
                    <Link to="/resgates">
                        <i className="fas fa-gift"></i> Solicitações de Resgate
                    </Link>
                </li>
                <li className={isActive('/usuarios')}>
                    <Link to="/usuarios">
                        <i className="fas fa-users"></i> Usuários
                    </Link>
                </li>
            </ul>
            <div className="sidebar-footer">
                {currentUser && (
                    <div style={{
                        padding: '12px',
                        marginBottom: '15px',
                        backgroundColor: 'rgba(255, 255, 255, 0.5)',
                        borderRadius: '8px',
                        color: '#000',
                        display: 'flex',
                        alignItems: 'center',
                        gap: '12px',
                        boxShadow: '0 2px 4px rgba(0,0,0,0.05)'
                    }}>
                        <i className="fas fa-user-circle" style={{ fontSize: '24px', color: '#333' }}></i>
                        <div style={{ overflow: 'hidden', display: 'flex', flexDirection: 'column' }}>
                            <span style={{ fontSize: '12px', color: '#333', marginBottom: '2px' }}>Logado como:</span>
                            <span style={{
                                fontWeight: 'bold',
                                fontSize: '14px',
                                color: '#000',
                                whiteSpace: 'nowrap',
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                                title: currentUser.displayName || currentUser.email
                            }}>
                                {currentUser.displayName || currentUser.email}
                            </span>
                        </div>
                    </div>
                )}
                <button onClick={handleLogout} className="logout-link" style={{ background: 'none', border: 'none', width: '100%', textAlign: 'left', cursor: 'pointer' }}>
                    <i className="fas fa-sign-out-alt"></i> Sair
                </button>
            </div>
        </div>
    );
};

export default Sidebar;
